import { render } from "./ComboField.vue?vue&type=template&id=99419f9a&scoped=true"
import script from "./ComboField.vue?vue&type=script&lang=js"
export * from "./ComboField.vue?vue&type=script&lang=js"

import "./ComboField.vue?vue&type=style&index=0&id=99419f9a&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-99419f9a"]])

export default __exports__